import { defineMessages } from 'react-intl';

export const createEditQuestionFormMessages = defineMessages({
  applyChanges: {
    id: `app.components.FormBuilder.QuestionTypeForms.CreateEditQuestion.applyChanges`,
    defaultMessage: 'Apply changes',
  },
});
